// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__pbxwv","header":"PatientBlock_header__8mIBO","label":"PatientBlock_label__3Dqib","option":"PatientBlock_option__DhIRt"};